
















































import commerceTypes from '@/store/types/drafts';
import { DraftCompanyParams } from '@/store/interfaces/drafts';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'CommerceInbound',
  data: () => ({
    detailCommerce: true,
    commerce_id: '',
    propsToSearch: ['commerce_name', 'business_name'] as tPropsToSearch,
    tableColumns: [
      {
        prop: 'commerce_name',
        label: '', // assigned in created
        minWidth: 260,
        sortable: true,
      },
      {
        prop: 'business_name',
        label: '', // Assigned in created
        minWidth: 260,
        sortable: true,
        formatter(row: DraftCompanyParams): string {
          return row.company_kind === 'natural' ? row.business_name : row.name;
        },
      },
      {
        prop: 'register_contact_phone',
        label: 'Número de contacto',
        minWidth: 220,
        sortable: true,
      },
      {
        prop: 'register_contact_email',
        label: 'Correo de contacto',
        minWidth: 250,
        sortable: true,
      }
    ] as tTableColumns,
    rowSelected: {
      accountant_contact: false,
      accountant_contact_email: '',
      accountant_contact_name: '',
      accountant_contact_phone: '',
      address_municipality: '',
      address_state_code: '',
      address_summary: '',
      bank_account: {
        account_holder: '',
        account_number: '',
        account_type: '',
        bank: {
          code: '',
          country_code: '',
          created_at: '',
          discarded_at: null,
          id: '',
          name: '',
          updated_at: '',
        },
        billing_address: null,
        billing_type: '',
        id: '',
        receipt_url: null,
      },
      id: '',
      banner_url: null,
      branches: [
        {
          address: '',
          contact_name: '',
          contact_phone: '',
          id: '',
          name: '',
          phone: '',
        }
      ],
      business_company_documents: [],
      business_name: '',
      business_nit: '',
      business_nrc: '',
      commerce_name: '',
      commission: null,
      company_kind: 'natural',
      dui: '',
      email: '',
      line: '',
      logo_url: null,
      name: '',
      nit: '',
      nrc: '',
      phone: '',
      register_contact: false,
      register_contact_email: null,
      register_contact_name: null,
      register_contact_phone: null,
      representative_company_documents: [],
      status: 'created',
    } as DraftCompanyParams,
    showevent: false,
  }),
  computed: {
    ...mapGetters({
      membershipList: `drafts/${commerceTypes.getters.GET_DRAFTS_COMPANIES}`,
    }),
  },
  created() {
    this.tableColumns[0].label = `Nombre del ${this.$t('menu.commerce.singular.informal')}`;
    this.tableColumns[1].label = `Nombre de la ${this.$t('menu.company.singular.informal').toString()}`;
  },
  methods: {
    ...mapActions({
      getMembershipList: `drafts/${commerceTypes.actions.DRAFTS_COMPANIES_LIST}`,
      singleInbound: `drafts/${commerceTypes.actions.SINGLE_DRAFT_COMPANY}`,
    }),
    rowSelect(row: DraftCompanyParams) {
      this.rowSelected = row;
    },
    editCommerceApprove() {
      this.$router.push({
        path: `/commerce/inbound/${this.rowSelected.id}`,
      });
      this.detailCommerce = false;
    },
  },
});
